import { useState } from "react";
import { toast } from "sonner";
import { Video, Copy, Mic, MicOff, VideoOff, PhoneOff, Link2 } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

export const VideoRoom = ({ lead, onHistory }) => {
  const [link, setLink] = useState(null);
  const [inCall, setInCall] = useState(false);
  const [mic, setMic] = useState(true);
  const [cam, setCam] = useState(true);
  const [notes, setNotes] = useState("");

  const genLink = () => {
    const url = `${window.location.origin}/sala/vendas-${Math.floor(100 + Math.random() * 899)}`;
    setLink(url);
    onHistory({ type: "video", text: `Link de reunião gerado: ${url}`, at: new Date().toLocaleString("pt-BR") });
    toast.success("Link de reunião gerado");
  };

  const endCall = () => {
    setInCall(false);
    if (notes.trim()) {
      onHistory({ type: "video", text: `Anotações da reunião: ${notes.trim()}`, at: new Date().toLocaleString("pt-BR") });
    }
    toast("Reunião encerrada", { description: "Anotações salvas no histórico." });
    setNotes("");
  };

  return (
    <div className="space-y-3" data-testid="lead-video-panel">
      {!link && (
        <button data-testid="video-gen-link-btn" onClick={genLink} className="flex w-full items-center justify-center gap-2 rounded-xl bg-violet-600 py-3 text-sm font-bold text-white transition-colors hover:bg-violet-700">
          <Link2 className="h-4 w-4" />Gerar Link de Reunião
        </button>
      )}

      {link && !inCall && (
        <div className="space-y-3">
          <div className="flex items-center justify-between rounded-xl border border-violet-200 bg-violet-50 px-3 py-2.5">
            <span data-testid="video-link" className="truncate font-mono-num text-xs font-semibold text-violet-700">{link}</span>
            <div className="ml-2 flex shrink-0 items-center gap-2">
              <button onClick={() => window.open(link, "_blank", "noopener")} data-testid="video-open-link" className="text-violet-500 hover:text-violet-700"><Video className="h-4 w-4" /></button>
              <button onClick={() => { navigator.clipboard?.writeText(link); toast.success("Link copiado"); }} className="text-violet-500 hover:text-violet-700"><Copy className="h-4 w-4" /></button>
            </div>
          </div>
          <button data-testid="video-start-btn" onClick={() => setInCall(true)} className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 py-3 text-sm font-bold text-white transition-colors hover:bg-slate-800">
            <Video className="h-4 w-4" />Entrar na Sala de Reunião
          </button>
        </div>
      )}

      {inCall && (
        <div className="grid gap-3 lg:grid-cols-2" data-testid="video-room-live">
          {/* área de vídeo */}
          <div className="relative flex aspect-video items-center justify-center overflow-hidden rounded-xl bg-slate-900">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/10 text-xl font-bold text-white">
              {lead.contact.charAt(0)}
            </div>
            <span className="absolute left-2 top-2 rounded-md bg-black/40 px-2 py-0.5 text-[10px] font-semibold text-white">{lead.contact}</span>
            {!cam && <div className="absolute inset-0 flex items-center justify-center bg-slate-800 text-xs text-slate-400">Câmera desligada</div>}
            <div className="absolute inset-x-0 bottom-2 flex justify-center gap-2">
              <button onClick={() => setMic((m) => !m)} data-testid="video-mic-toggle" className={`flex h-8 w-8 items-center justify-center rounded-full ${mic ? "bg-white/15 text-white" : "bg-rose-500 text-white"}`}>{mic ? <Mic className="h-4 w-4" /> : <MicOff className="h-4 w-4" />}</button>
              <button onClick={() => setCam((c) => !c)} data-testid="video-cam-toggle" className={`flex h-8 w-8 items-center justify-center rounded-full ${cam ? "bg-white/15 text-white" : "bg-rose-500 text-white"}`}>{cam ? <Video className="h-4 w-4" /> : <VideoOff className="h-4 w-4" />}</button>
              <button onClick={endCall} data-testid="video-end-btn" className="flex h-8 w-8 items-center justify-center rounded-full bg-rose-600 text-white hover:bg-rose-700"><PhoneOff className="h-4 w-4" /></button>
            </div>
          </div>
          {/* anotações */}
          <div className="flex flex-col">
            <label className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-400">Anotações de Negociação</label>
            <Textarea data-testid="video-notes" value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Objeções, próximos passos, proposta discutida..." className="min-h-[140px] flex-1 resize-none" />
          </div>
        </div>
      )}
    </div>
  );
};
